import React from 'react';
import Logo from './fullLogo.svg?react';
import { useResolveMantineColor } from 'src/UI/theme/theme';

type Props = {
  height?: string | number | undefined;
  color?: string;
};

export default function FullLogoIcon({ height, color = 'white' }: Props) {
  const resolvedColour = useResolveMantineColor(color);
  return <Logo fill={resolvedColour} height={height} />;
}
